import {AnyCustomModelJson} from "./CustomModelJson";
import {ModelPlatform} from "../enum/ModelPlatform"
import React from "react"

export interface CustomModelStatus {
    label: string
    time: string
    muiColor: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
    failedReason?: string | null
    percentProgress?: number
}

export function resolveFinetuneStatus(customModel: AnyCustomModelJson): CustomModelStatus {
    if (customModel.completed) {
        return {label: "Complete", time: customModel.completed, muiColor: "success"}
    } else if (customModel.failed) {
        return {label: "Failed", time: customModel.failed, muiColor: "error", failedReason: customModel.failedReason}
    } else if (customModel.started) {
        return {label: "Started", time: customModel.created, muiColor: "secondary"}
    } else {
        return {label: "Preparing", time: customModel.created, muiColor: "secondary"}
    }
}